<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Gói cước chung" id="general-package-box">
          <div slot="content">
            <b-tabs>
              <b-tab
                v-for="tab in tabs"
                :key="tab.value"
                :title="tab.label"
                :active="tab.value===generalPackageActiveTab"
                @click="() => generalPackageActiveTab=tab.value"
                style="color: black"
              />
            </b-tabs>
          <b-table    bordered outlined hover fixed responsive :busy="loadingGeneral" :fields="fields" :items="generalPackages[generalPackageActiveTab]"
                      show-empty>
            <template #table-busy>
              <div class="text-center my-2 mt-5 mb-5">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Đang tải...</strong>
              </div>
            </template>
            <template #empty="scope">
              <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
            </template>
            <template v-slot:cell(startAt)="data">
              <span v-if="generalPackages[generalPackageActiveTab][data.index - 1]">
                {{generalPackages[generalPackageActiveTab][data.index - 1].endAt}}
              </span>
              <span v-else>0</span>
            </template>
            <template v-slot:cell()="data">
              <span v-if="generalPackageActiveTab !== isEditGeneralPackage.tab || isEditGeneralPackage.index !== data.index || (data.field.key==='endAt' && data.index === generalPackages[generalPackageActiveTab].length - 1)">
                {{generalPackages[generalPackageActiveTab][data.index][data.field.key]}}
                {{data.field.key === 'endAt' && generalPackages[generalPackageActiveTab][data.index].endAt === '' ? 'Không giới hạn' : ''}}
              </span>
              <b-form-input
                size="md"
                v-else
                type="number"
                v-model.number="generalPackages[generalPackageActiveTab][data.index][data.field.key]"
                :state="(data.field.key === 'endAt' && isEditGeneralPackage.index === data.index) ? isValidEditGeneralPackage : null"
              />
            </template>
            <template v-slot:cell(actions)="dataId">
              <b-button v-if="dataId.index === 0 && generalPackages[generalPackageActiveTab].length === 1" variant="primary" v-b-tooltip.hover title="Thêm block đầu tiên"
                        @click="insertFirstGeneralPackage"><i
                class="fa fa-plus"/></b-button>
              <b-button variant="warning" v-b-tooltip.hover title="Cập nhật" @click="editGeneralPackage(dataId.index)"
                        >
                <i :class="generalPackageActiveTab !== isEditGeneralPackage.tab || isEditGeneralPackage.index !== dataId.index  ? 'fa fa-edit' :'fa fa-floppy-o'"/>
              </b-button>
              <b-button v-if="dataId.index !== generalPackages[generalPackageActiveTab].length - 1" variant="danger" v-b-tooltip.hover title="Xoá"
                        @click="deleteGeneralPackage(dataId.index)"><i
                class="fa fa-trash"/></b-button>
              <b-button v-if="isEnableAddingGeneralPackage(dataId.index)" variant="success" v-b-tooltip.hover title="Thêm một block ngay sau"
                        @click="insertGeneralPackage(dataId.index)"><i
                class="fa fa-plus"/></b-button>
            </template>

          </b-table>
          </div>
        </va-box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Gói cước từng công ty">
          <div slot="content" class="d-flex flex-column">
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Tên công ty</label>
              <input type="text" class="form-control"
                     placeholder="Nhập tên công ty ..."
                     v-model="filterData.companyName"
              />
            </div>
            <div class="d-flex align-items-center" style="margin: 0px 15px 15px; gap: 10px">
              <b-button variant="warning" @click="filterCompanyPackage(true)">
                <span class="glyphicon glyphicon-search" aria-hidden="true"></span>Tìm kiếm
              </b-button>
              <b-button variant="success" @click="openModalAddCompany">
                <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>Thêm mới
              </b-button>
            </div>
            <b-table-simple bordered outlined responsive :busy="loading" id="company-packages-table">
              <b-thead>
                <b-tr>
                  <b-th v-for="field in companyFields" v-bind:key="field.key" :class="field.thClass" :style="field.companyTableStyle || {}">
                    {{field.label}}
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody v-if="loading">
                <b-tr>
                  <b-td colspan="5" style="padding: 100px 0; text-align: center">
                    <b-spinner class="align-middle"/>
                    <strong>Đang tải...</strong>
                  </b-td>
                </b-tr>
              </b-tbody>
              <b-tbody v-else>
                <template v-for="(company, companyIndex) in companies">
                  <b-tr v-bind:key="companyIndex">
                    <b-th :rowspan="company[company.activeTab].length" class="p-0 position-relative fix-height">
                      <div style="display: table; width: 100%; height: 100%;">
                        <div style="display: table-cell; padding: 2px; word-wrap: break-word; vertical-align: middle; width: 100%">
                          {{company.company_name}}
                        </div>
                        <b-tabs pills card vertical content-class="d-none"
                                class="provider-table"
                                style="display:table; width: 130px; height: 100%;"
                        >
                          <b-tab
                            v-for="tab in tabs"
                            v-bind:key="tab.value"
                            :title="tab.label"
                            :active="tab.value === company.activeTab"
                            @click="() => companies[companyIndex].activeTab = tab.value"
                          />
                        </b-tabs>
                      </div>

                    </b-th>
                    <b-td style="vertical-align: middle">0</b-td>
                    <b-td class="align-middle">
                      <span v-if="!isEditingCompanyPackage(companyIndex, 0) || company[company.activeTab].length === 1">
                        {{
                          !company[company.activeTab][0].endAt ?
                            'Không giới hạn' : company[company.activeTab][0].endAt
                        }}
                      </span>
                      <b-form-input
                        v-else
                        type="number"
                        v-model.number="company[company.activeTab][0].endAt"
                        :state="isEditingCompanyPackage(companyIndex, 0) ? isValidEditCompanyPackage : null"
                      />
                    </b-td>
                    <b-td class="align-middle">
                      <span v-if="!isEditingCompanyPackage(companyIndex, 0)">
                        {{companies[companyIndex][company.activeTab][0].unitPrice}}
                      </span>
                      <b-form-input
                        v-else
                        type="number"
                        v-model.number="companies[companyIndex][company.activeTab][0].unitPrice"
                      />
                    </b-td>
                    <b-td class="align-middle">
                      <b-button v-if="company[company.activeTab].length === 1" variant="primary" v-b-tooltip.hover title="Thêm block đầu tiên"
                                @click="insertFirstCompanyPackage(companyIndex)"><i
                        class="fa fa-plus"/></b-button>
                      <b-button variant="warning" v-b-tooltip.hover title="Cập nhật" @click="editCompanyPackage(companyIndex, 0)"
                      >
                        <i :class="!isEditingCompanyPackage(companyIndex, 0) ? 'fa fa-edit' : 'fa fa-floppy-o'"/>
                      </b-button>
                      <b-button v-if="company[company.activeTab].length > 1" variant="danger" v-b-tooltip.hover title="Xoá"
                                @click="deleteCompanyPackage(companyIndex, 0)"><i
                        class="fa fa-trash"/></b-button>
                      <b-button v-if="isEnableAddingCompanyPackage(companyIndex,0)" variant="success" v-b-tooltip.hover title="Thêm một block ngay sau"
                                @click="insertCompanyPackage(companyIndex, 0)"><i
                        class="fa fa-plus"/></b-button>
                    </b-td>
                    <b-td :rowspan="company[company.activeTab].length" style="vertical-align: middle; text-align: center">
                      <b-button variant="danger" @click="deleteCompany(companyIndex)">
                        Xoá công ty
                      </b-button>
                    </b-td>
                  </b-tr>
                  <template v-for="(p, pIndex) in company[company.activeTab].slice(1)">
                    <b-tr v-bind:key="p.id">
                      <b-td style="vertical-align: middle">
                        <span>
                          {{companies[companyIndex][company.activeTab][pIndex].endAt}}
                        </span>
                      </b-td>
                      <b-td class="align-middle">
                        <span v-if="!isEditingCompanyPackage(companyIndex, pIndex + 1) || pIndex + 1 === company[company.activeTab].length - 1">
                          {{!company[company.activeTab][pIndex + 1].endAt ? 'Không giới hạn' : company[company.activeTab][pIndex + 1].endAt}}
                        </span>
                        <b-form-input
                          v-else
                          type="number"
                          v-model.number="companies[companyIndex][company.activeTab][pIndex + 1].endAt"
                          :state="isEditingCompanyPackage(companyIndex, pIndex + 1) ? isValidEditCompanyPackage : null"
                        />
                      </b-td>
                      <b-td class="align-middle">
                        <span v-if="!isEditingCompanyPackage(companyIndex, pIndex + 1)">
                          {{companies[companyIndex][company.activeTab][pIndex + 1].unitPrice}}
                        </span>
                        <b-form-input
                          v-else
                          type="number"
                          v-model.number="companies[companyIndex][company.activeTab][pIndex + 1].unitPrice"
                        />
                      </b-td>
                      <b-td v-bind:key="p.id + 'action'" class="align-middle">
                        <b-button variant="warning" v-b-tooltip.hover title="Cập nhật" @click="editCompanyPackage(companyIndex, pIndex + 1)"
                        >
                          <i :class="!isEditingCompanyPackage(companyIndex, pIndex + 1) ? 'fa fa-edit' : 'fa fa-floppy-o'"/>
                        </b-button>
                        <b-button v-if="pIndex + 1 !== company[company.activeTab].length - 1" variant="danger" v-b-tooltip.hover title="Xoá"
                                  @click="deleteCompanyPackage(companyIndex, pIndex + 1)"><i
                          class="fa fa-trash"/></b-button>
                        <b-button v-if="isEnableAddingCompanyPackage(companyIndex, pIndex + 1)" variant="success" v-b-tooltip.hover title="Thêm một block ngay sau"
                                  @click="insertCompanyPackage(companyIndex, pIndex + 1)"><i
                          class="fa fa-plus"/></b-button>
                      </b-td>
                    </b-tr>
                  </template>
                </template>
              </b-tbody>

            </b-table-simple>

          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
        <b-modal size='lg' id='selectCompanyToAdd' hide-footer title="Chọn công ty" @hide="filterCompanyPackage">
          <div class="form-group col-md-12 col-sm-12 col-xs-12">
            <CompanyTable />
          </div>
        </b-modal>
      </div>
    </section>
  </div>
</template>

<script>
import {isEmpty, find} from 'lodash'
import VABox from 'va/widgets/VABox.vue'
import Vue from 'vue'
import PackageAPI from '../../api/package'
import Utils from '../../common/utils'
import CompanyTable from '../../components/CompanyTable'

export default {
  name: 'Package',
  components: {
    'va-box': VABox,
    'CompanyTable': CompanyTable
  },
  data () {
    return {
      loading: false,
      loadingGeneral: false,
      tabs: [
        {
          label: 'Viettel',
          value: 'viettel'
        },
        {
          label: 'Vinaphone',
          value: 'vinaphone'
        },
        {
          label: 'Mobifone',
          value: 'mobifone'
        },
        {
          label: 'Ngoại mạng',
          value: 'other'
        }
      ],
      generalPackages: {
        viettel: [],
        vinaphone: [],
        mobifone: [],
        other: []
      },
      generalPackageActiveTab: 'viettel',
      isEditGeneralPackage: {},
      companies: [],
      isEditCompanyPackage: {},
      fields: [
        {
          key: 'startAt',
          label: 'Giá trị bắt đầu',
          thClass: 'align-middle',
          tdClass: 'align-middle',
          companyTableStyle: {width: '18%'}
        },
        {
          key: 'endAt',
          label: 'Giá trị kết thúc',
          thClass: 'align-middle',
          tdClass: 'align-middle',
          companyTableStyle: {width: '18%'}
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá',
          thClass: 'align-middle',
          tdClass: 'align-middle',
          companyTableStyle: {width: '18%'}
        },
        {
          key: 'actions',
          label: 'Hành động',
          thStyle: 'width: 140px',
          class: 'actions-cell',
          thClass: 'align-middle',
          tdClass: 'align-middle',
          companyTableStyle: {width: '150px'}
        }
      ],
      generalPage: {
        pageSize: 10,
        currentPage: 1,
        totalRow: 0,
      },
      filterData: {
        companyName: ''
      },
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
    }
  },
  computed: {
    companyFields () {
      return [
        {
          key: 'companyName',
          label: 'Công ty',
          companyTableStyle: {width: '25%'}
        },
        ...this.fields,
        {
          key: 'deleteCompany',
          label: '',
        }
      ]
    },
    isValidEditGeneralPackage () {
      if (isEmpty(this.isEditGeneralPackage)) return null
      const {index} = this.isEditGeneralPackage
      const currentTab = this.generalPackages[this.generalPackageActiveTab]
      if (this.generalPackageActiveTab === this.isEditGeneralPackage.tab) {
        if (index < currentTab.length - 1 && !currentTab[index].endAt) return false
        if (currentTab[index - 1] && currentTab[index].endAt && currentTab[index].endAt <= currentTab[index - 1].endAt) return false
        if (currentTab[index + 1] && currentTab[index + 1].endAt && currentTab[index + 1].endAt <= currentTab[index].endAt) return false
      }
      return null
    },
    isValidEditCompanyPackage () {
      if (isEmpty(this.isEditCompanyPackage)) return null
      const {index, companyIndex} = this.isEditCompanyPackage
      const company = this.companies[companyIndex]
      const currentTab = company[company.activeTab]
      if (this.isEditCompanyPackage.tab === company.activeTab) {
        if (index === currentTab.length - 1) return null
        if (index < currentTab.length - 1 && !currentTab[index].endAt) return false
        if (currentTab[index - 1] && currentTab[index].endAt && currentTab[index].endAt <= currentTab[index - 1].endAt) return false
        if (currentTab[index + 1] && currentTab[index + 1].endAt && currentTab[index + 1].endAt <= currentTab[index].endAt) return false
      }
      return null
    }
  },
  async mounted () {
    await Promise.all([this.getGeneralPackage(), this.filterCompanyPackage(true)])
  },
  methods: {
    isEnableAddingGeneralPackage (index) {
      const currentTab = this.generalPackages[this.generalPackageActiveTab]
      if (!currentTab[index].endAt) return false
      if (currentTab[index] && currentTab[index + 1] && currentTab[index].endAt + 1 === currentTab[index + 1].endAt) return false
      return this.isValidEditGeneralPackage !== false
    },
    isEnableAddingCompanyPackage (companyIndex, index) {
      const company = this.companies[companyIndex]
      const {activeTab} = company
      if (!company[activeTab][index].endAt) return false
      if (company[activeTab][index] && company[activeTab][index + 1] && company[activeTab][index].endAt + 1 === company[activeTab][index + 1].endAt) return false
      return this.isValidEditCompanyPackage !== false
    },
    async getGeneralPackage () {
      try {
        this.loadingGeneral = true
        const response = await PackageAPI.findById(null)
        if (response.data.data) {
          const {data} = response.data
          Object.keys(data).filter(key => key in this.generalPackages).forEach(key => {
            this.generalPackages[key] = JSON.parse(data[key])
          })
        }
      } catch (e) {
        Utils.handleError(this.$bvToast, e)
      } finally {
        this.loadingGeneral = false
      }
    },
    changeGeneralTab (tab) {
      Vue.set(this.generalPackageActiveTab, tab)
    },
    insertFirstGeneralPackage () {
      const currentTab = this.generalPackages[this.generalPackageActiveTab]
      currentTab.unshift(
        {
          endAt: 100,
          unitPrice: 0
        }
      )
      this.isEditGeneralPackage = {
        tab: this.generalPackageActiveTab,
        index: 0,
        defaultValue: {
          endAt: 100,
          unitPrice: 0
        }
      }
    },
    async insertGeneralPackage (index) {
      if (!isEmpty(this.isEditGeneralPackage)) {
        Vue.set(this.generalPackages[this.isEditGeneralPackage.tab], this.isEditGeneralPackage.index, this.isEditGeneralPackage.defaultValue)
        try {
          await PackageAPI.update(this.getUpdateRequest())
        } catch (e) {
          Utils.handleError(this.$bvToast, e)
        }
      }
      const currentTab = this.generalPackages[this.generalPackageActiveTab]
      currentTab.splice(index + 1, 0, {
        endAt: currentTab[index].endAt + 1,
        unitPrice: 0
      })
      this.isEditGeneralPackage = {
        tab: this.generalPackageActiveTab,
        index: index + 1,
        defaultValue: {...currentTab[index + 1]}
      }
    },
    async editGeneralPackage (index) {
      if (index === this.isEditGeneralPackage.index && this.generalPackageActiveTab === this.isEditGeneralPackage.tab) {
        if (this.isValidEditGeneralPackage === false) return
        try {
          await PackageAPI.update(this.getUpdateRequest())
          this.isEditGeneralPackage = {}
        } catch (e) {
          Utils.handleError(this.$bvToast, e)
        }
      } else {
        if (!isEmpty(this.isEditGeneralPackage)) {
          Vue.set(this.generalPackages[this.isEditGeneralPackage.tab], this.isEditGeneralPackage.index, this.isEditGeneralPackage.defaultValue)
          try {
            await PackageAPI.update(this.getUpdateRequest())
            this.isEditGeneralPackage = {
              tab: this.generalPackageActiveTab,
              index,
              defaultValue: {...this.generalPackages[this.generalPackageActiveTab][index]}
            }
          } catch (e) {
            Utils.handleError(this.$bvToast, e)
          }
        } else {
          this.isEditGeneralPackage = {
            tab: this.generalPackageActiveTab,
            index,
            defaultValue: {...this.generalPackages[this.generalPackageActiveTab][index]}
          }
        }
      }
    },
    async deleteGeneralPackage (index) {
      const currentTab = this.generalPackages[this.generalPackageActiveTab]
      if (this.isValidEditGeneralPackage === false && !isEmpty(this.isEditGeneralPackage)) {
        Vue.set(this.generalPackages[this.isEditGeneralPackage.tab], this.isEditGeneralPackage.index, this.isEditGeneralPackage.defaultValue)
      }

      if (currentTab[index]) {
        const [removedPackage] = currentTab.splice(index, 1)
        try {
          await PackageAPI.update(this.getUpdateRequest())
          this.isEditGeneralPackage = {}
        } catch (e) {
          currentTab.splice(index, 0, removedPackage)
          Utils.handleError(this.$bvToast, e)
        }
      }
    },
    async filterCompanyPackage (isSearch = false) {
      const page = isSearch ? 0 : this.currentPage - 1
      try {
        this.loading = true
        const response = await PackageAPI.filter({
          company_name: this.filterData.companyName
        }, page, this.pageSize)
        if (response.data.data) {
          const {data} = response.data
          this.pageSize = data.page_size
          this.totalRow = data.total
          this.companies = data.records.map(record => {
            let company = {}
            for (const key in record) {
              company[key] = ['viettel', 'vinaphone', 'mobifone', 'other'].includes(key) ? JSON.parse(record[key]) : record[key]
            }
            company.activeTab = 'viettel'
            return company
          })
        }
      } catch (e) {
        Utils.handleError(this.$bvToast, e)
      } finally {
        this.loading = false
      }
    },
    isEditingCompanyPackage (companyIndex, index) {
      const company = this.companies[companyIndex]
      const {activeTab} = company
      return companyIndex === this.isEditCompanyPackage.companyIndex && index === this.isEditCompanyPackage.index && activeTab === this.isEditCompanyPackage.tab
    },
    insertFirstCompanyPackage (companyIndex) {
      const company = this.companies[companyIndex]
      const {activeTab} = company
      company[activeTab].unshift(
        {
          endAt: 100,
          unitPrice: 0
        }
      )
      this.isEditCompanyPackage = {
        companyIndex,
        index: 0,
        tab: activeTab,
        defaultValue: {
          endAt: 100,
          unitPrice: 0
        }
      }
    },
    async insertCompanyPackage (companyIndex, index) {
      if (!isEmpty(this.isEditCompanyPackage)) {
        Vue.set(
          this.companies[this.isEditCompanyPackage.companyIndex][this.isEditCompanyPackage.tab],
          this.isEditCompanyPackage.index,
          this.isEditCompanyPackage.defaultValue
        )
        try {
          await PackageAPI.update(this.getUpdateRequest(this.companies[this.isEditCompanyPackage.companyIndex].id))
        } catch (e) {
          Utils.handleError(this.$bvToast, e)
        }
      }
      const company = this.companies[companyIndex]
      const {activeTab} = company
      company[activeTab].splice(index + 1, 0, {
        endAt: company[activeTab][index].endAt + 1,
        unitPrice: 0
      })
      this.isEditCompanyPackage = {
        companyIndex,
        index: index + 1,
        tab: activeTab,
        defaultValue: {...company[activeTab][index + 1]}
      }
    },
    async editCompanyPackage (companyIndex, index) {
      const company = this.companies[companyIndex]
      const {activeTab} = company
      if (this.isEditingCompanyPackage(companyIndex, index)) {
        if (this.isValidEditCompanyPackage === false) return
        try {
          await PackageAPI.update(this.getUpdateRequest(company.id))
          this.isEditCompanyPackage = {}
        } catch (e) {
          Utils.handleError(this.$bvToast, e)
        }
      } else {
        if (!isEmpty(this.isEditCompanyPackage)) {
          Vue.set(
            this.companies[this.isEditCompanyPackage.companyIndex][this.isEditCompanyPackage.tab],
            this.isEditCompanyPackage.index,
            this.isEditCompanyPackage.defaultValue
          )
          try {
            await PackageAPI.update(this.getUpdateRequest(company.id))
            this.isEditCompanyPackage = {
              companyIndex,
              index,
              tab: activeTab,
              defaultValue: {...company[activeTab][index]}
            }
          } catch (e) {
            Utils.handleError(this.$bvToast, e)
          }
        } else {
          this.isEditCompanyPackage = {
            companyIndex,
            index,
            tab: activeTab,
            defaultValue: {...company[activeTab][index]}
          }
        }
      }
    },
    async deleteCompanyPackage (companyIndex, index) {
      if (this.isValidEditGeneralPackage === false && !isEmpty(this.isEditCompanyPackage)) {
        Vue.set(
          this.companies[this.isEditCompanyPackage.companyIndex][this.isEditCompanyPackage.tab],
          this.isEditCompanyPackage.index,
          this.isEditCompanyPackage.defaultValue
        )
      }
      const company = this.companies[companyIndex]
      const {activeTab} = company
      const currentTab = company[activeTab]
      if (currentTab[index]) {
        const [removedPackage] = currentTab.splice(index, 1)
        try {
          await PackageAPI.update(this.getUpdateRequest(company.id))
          this.isEditCompanyPackage = {}
        } catch (e) {
          currentTab.splice(index, 0, removedPackage)
          Utils.handleError(this.$bvToast, e)
        }
      }
    },
    async deleteCompany (companyIndex) {
      if (this.companies[companyIndex]) {
        try {
          await PackageAPI.remove(this.companies[companyIndex].id)
          this.companies.splice(companyIndex, 1)
          this.isEditCompanyPackage = {}
        } catch (err) {
          Utils.handleError(this.$bvToast, err)
        }
      }
    },
    openModalAddCompany () {
      this.$bvModal.show('selectCompanyToAdd')
    },
    getUpdateRequest (id = null) {
      const company = id !== null ? find(this.companies, {id}) : null
      let request = company ? {company_id: company.company_id, id} : {id: null}
      const data = company || this.generalPackages
      for (const key in data) {
        if (key in this.generalPackages) {
          request[key] = JSON.stringify(data[key])
        }
      }
      return request
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filterCompanyPackage()
      }
    },
    pageSize: {
      handler: function () {
        this.filterCompanyPackage()
      }
    },
  }
}
</script>

<style lang="scss">
  #general-package-box {
    ul[role="tablist"] {
      a[role="tab"]{
        color: black;
      }
    }
  }
  #company-packages-table {
    .fix-height {
      height: 1px;
    }
    @-moz-document url-prefix() {
      .fix-height {
        height: 100%;
      }
    }
    .provider-table > div:first-child {
      display: table-cell;
      height: 100%;
    }
    ul[role="tablist"] {
      padding: 0;
      li.nav-item {
        margin-left: unset;
        height: 25%;
        display: flex;
        justify-content: center;
        align-items: stretch;
        background-color: white;
      }
      a[role="tab"]{
        color: black;
        background-color: white;
        margin-right: -1px;
      }
      a[role="tab"][aria-selected=true]{
        border-width: 1px !important;
        border-right-color: white !important;
        border-radius: 4px 0 0 4px;
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: linear-gradient(to right, #a3ce71, white 60%);
        color: black;
      }
      li.nav-item:first-child {
        a[role="tab"][aria-selected=true]{
          border-top: 0;
          border-radius: 0 0 0 4px;
        }
      }
      li.nav-item:last-child {
        a[role="tab"][aria-selected=true]{
          border-bottom: 0;
          border-radius: 4px 0 0 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/Package.vue